import { useContext } from "react";
import { TaskManagerContext } from "../context/TaskManagerContext";

export function useTaskManager() {
    const context = useContext(TaskManagerContext);

    if(context == undefined)
        throw new Error("TaskManagerContext debe ser usado dentro de TaskManagerProvider.");

    return context;
}